import React from "react";
import styles from "../procedure-details.module.scss";
import { ProcedureImage } from "./ProcedureImage";

export function ProcedureImagesSet({
  drawings_image,
  leftImage,
  frontImage,
  rightImage,
  openLightbox,
}) {
  return (
    <>
      {drawings_image ? (
        <div className={styles.procedureImage}>
          <ProcedureImage
            src={drawings_image}
            openLightbox={openLightbox}
            alt="Procedure Image"
            imageType="horizontal"
          />
        </div>
      ) : (
        <div className="row">
          <div className="col-sm-4 col-xs-12">
            <div className="procedure-img">
              <ProcedureImage
                src={leftImage}
                openLightbox={openLightbox}
                alt="Left Image"
                imageType="vertical"
              />
            </div>
          </div>
          <div className="col-sm-4 col-xs-12">
            <div className="procedure-img">
              <ProcedureImage
                src={frontImage}
                openLightbox={openLightbox}
                alt="Front Image"
                imageType="vertical"
              />
            </div>
          </div>
          <div className="col-sm-4 col-xs-12">
            <div className="procedure-img">
              <ProcedureImage
                src={rightImage}
                openLightbox={openLightbox}
                alt="Right Image"
                imageType="vertical"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
